import {
  Component,
  ElementRef,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormControl } from '@angular/forms';

declare const google: any;

@Component({
    selector: 'formly-google-places',
    template: `
   <div class="row mb-3">
  <div class="col-md-4">
    <label class="form-label">{{'Country' | translate}} <span *ngIf="props.required">*</span></label>
    <input #countryInput
      type="text"
      class="form-control"
      placeholder="{{'Select country' | translate}}"
    />
  </div>

  <div class="col-md-4">
    <label class="form-label">{{'Region' | translate}}</label>
    <input #regionInput
      type="text"
      class="form-control"
      placeholder="{{'all_f' | translate}}"
      [disabled]="!selectedCountry"
    />
  </div>

  <div class="col-md-4">
    <label class="form-label">{{'District' | translate}}</label>
    <input #districtInput
      type="text"
      class="form-control"
      placeholder="{{'Select district' | translate}}"
      [disabled]="!selectedRegion"
    />
  </div>
</div>

  `,
    standalone: false
})
export class FormlyGooglePlacesComponent extends FieldType implements AfterViewInit {
  @ViewChild('countryInput', { static: true }) countryInput!: ElementRef;
  @ViewChild('regionInput', { static: true }) regionInput!: ElementRef;
  @ViewChild('districtInput', { static: true }) districtInput!: ElementRef;

  selectedCountry: string | null = null;
  selectedRegion: string | null = null;

  private regionAutocomplete!: any;
  private districtAutocomplete!: any;

  ngAfterViewInit() {
    this.initCountryAutocomplete();
    this.initRegionAutocomplete();
    this.initDistrictAutocomplete();
  }

  initCountryAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.countryInput.nativeElement, {
      types: ['(regions)'],
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      const country = this.getAddressComponent(place, 'country');

      this.selectedCountry = country;
      this.selectedRegion = null;

      this.formControl.setValue({ country });

      if (this.regionAutocomplete) {
        this.regionAutocomplete.setComponentRestrictions({ country });
      }
      if (this.districtAutocomplete) {
        this.districtAutocomplete.setComponentRestrictions({ country });
      }
    });
  }

  initRegionAutocomplete() {
    this.regionAutocomplete = new google.maps.places.Autocomplete(this.regionInput.nativeElement, {
      types: ['(regions)'],
    });

    this.regionAutocomplete.addListener('place_changed', () => {
      const place = this.regionAutocomplete.getPlace();
      const region = this.getAddressComponent(place, 'administrative_area_level_1');

      this.selectedRegion = region;
      const currentValue = this.formControl.value || {};
      this.formControl.setValue({ ...currentValue, region });
    });
  }

  initDistrictAutocomplete() {
    this.districtAutocomplete = new google.maps.places.Autocomplete(this.districtInput.nativeElement, {
      types: ['(regions)'],
    });

    this.districtAutocomplete.addListener('place_changed', () => {
      const place = this.districtAutocomplete.getPlace();
      const district = this.getAddressComponent(place, 'administrative_area_level_2');

      const currentValue = this.formControl.value || {};
      this.formControl.setValue({ ...currentValue, district });
    });
  }

  private getAddressComponent(place: any, type: string): string {
    const comp = place.address_components?.find((c: any) => c.types.includes(type));
    return comp ? comp.short_name : '';
  }

  get control(): FormControl {
    return this.formControl as FormControl;
  }

}
